

















import { Component, Prop, Watch, Vue} from 'vue-property-decorator';
import * as dayjs from 'dayjs';
import VueApexCharts from 'vue-apexcharts';
import HeatmapService from '../services/HeatmapService';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

@Component
export default class CountHeatmapChart extends Vue {

    public year: number = 2020;

    public series: any = [];

    public heatmapOptions = {
        plotOptions: {
            heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: false,
            colorScale: {
                    ranges: [
                        {
                            from: 0,
                            to: 1,
                            name: 'Not in Range',
                            color: '#f2f3f4',
                        },
                        {
                            from: 1,
                            to: 200,
                            name: 'Low',
                            color: '#00A100',
                        },
                        {
                            from: 201,
                            to: 400,
                            name: 'Medium',
                            color: '#d0c64d',
                        },
                        {
                            from: 401,
                            to: 600,
                            name: 'High',
                            color: '#FFB200',
                        },
                        {
                            from: 601,
                            to: 100000,
                            name: 'Highest',
                            color: '#FF0000',
                        },
                    ],
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            width: 1,
        },
        title: {
            text: 'Heatmap by Date',
        },
        chart: {
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                },
            },
        },
        legend: {
            show: true,
            showForSingleSeries: true,
        },
    };

    public debounce: boolean = false;

    get startDate() {
        return this.$store.state.heatmap.startDate;
    }

    get endDate() {
        return this.$store.state.heatmap.endDate;
    }

    get showHeatmapChart() {
        return this.$store.state.heatmap.showHeatmapChart;
    }

    get map() {
        return this.$store.state.map;
    }

    get mapView() {
        return this.$store.state.mapView;
    }

    get dateCounts() {
        return this.$store.state.heatmap.dateCounts;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        // if (action.type === 'updateEndDate') {
        //     this.updateCountData();
        // }
    });

    @Watch('showHeatmapChart', { immediate: false, deep: false })
    public showChartChanged(value: boolean, oldValue: boolean) {
        if (value) {
            this.updateCountData();
        }
    }

    @Watch('dateCounts', { immediate: false, deep: false })
    public dateCountsChange(value: boolean, oldValue: boolean) {
        if (this.showHeatmapChart) {
            this.updateCountData();
        }
    }

    public toggleShow() {
        this.$store.dispatch('toggleHeatmapChart');
    }

    public updateCountData() {
        console.log('CountHeatmapChart: updateCountData()');
        if (this.dateCounts.length > 0) {
            const newXAxis: any = [];
            const newData: any = [];

            // empty all data for current year
            let newSeries: any = [];
            for (let month = 1; month <= 12; month++) {
                const daysInMonth = dayjs.default(this.year + '-' + month , 'YYYY-MM').daysInMonth();
                const monthText = dayjs.default(this.year + '-' + month , 'YYYY-MM').format('MMM');
                // console.log(month + ' ' + daysInMonth);
                newSeries.push({
                    name: monthText,
                    data: (new Array(daysInMonth)).fill(0, 0, daysInMonth),
                });

            }

            // inject response data into the series
            const activeMonthsIndexes: any = [];
            this.dateCounts.forEach((element: any) => {
                const dataDate: any = dayjs.default(element.date);
                newSeries[parseInt(dataDate.format('M'), 10) - 1].data[parseInt(dataDate.format('D'), 10) - 1] = element.count;
                activeMonthsIndexes.push(dataDate.format('MMM'));
            });

            // delete months with no data
            newSeries = newSeries.filter((serie: any) => activeMonthsIndexes.indexOf(serie.name) !== -1);
            newSeries = newSeries.reverse();

            this.series = newSeries;
        }
    }

    public mounted() {
        console.log('CountHeatmapChart: mounted()');
    }

    public beforeDestroy() {
        console.log('CountHeatmapChart: beforeDestroy()');
        this.unsubscribe();
    }

}

